import { ThemeProvider } from "styled-components";
import RoutesComponent from "./routes";
import theme from "./styles/theme";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { LoaderProvider } from "./context/useLoaderContext";
import { CloudPContentProvider } from "./context/useCPContentContext";
import { SidemenuProvider } from "./context/useSideMenuContext";
import { NavigationBlockProvider } from "./context/useBlockNavigationContext";

function App() {
  // window.console.log = () => {};
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <NavigationBlockProvider>
          <LoaderProvider>
            <SidemenuProvider>
              <CloudPContentProvider>
                <RoutesComponent />
              </CloudPContentProvider>
            </SidemenuProvider>
          </LoaderProvider>
        </NavigationBlockProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
